var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createReducer } from "redux-act";
import * as actions from "./featureFlag.actions";
export var REDUCER_KEY_FEATURE_FLAG = "featureFlag";
var getDefaultState = function () { return ({
    isFetching: false,
    fetchError: undefined,
    flags: undefined,
}); };
var reducer = createReducer({}, getDefaultState());
// reducer.on("LOG_OUT", () => getDefaultState());
reducer.on(actions.getFlags.types.SUCCESS, function (state, _a) {
    var flags = _a.flags;
    return __assign(__assign({}, state), { isFetching: false, fetchError: undefined, flags: flags });
});
reducer.on(actions.getFlags.types.FAILURE, function (state, _a) {
    var error = _a.error;
    return __assign(__assign({}, state), { isFetching: false, fetchError: error });
});
// eslint-disable-next-line import/no-default-export
export default reducer;
